import Nav from "./Nav";
import { AiFillDatabase } from "react-icons/ai";
import { AiFillControl } from "react-icons/ai";
import { AiFillDollarCircle } from "react-icons/ai";
import { AiFillLike } from "react-icons/ai";
import { AiFillSmile } from "react-icons/ai";
import { AiFillCheckCircle } from "react-icons/ai";
import { AiFillSecurityScan } from "react-icons/ai";
import Hire from "./Hire";
import CTA_hired from "./CTA_hired";
import Benefits from "./Benefits";
import FAQHandy from "./FAQ_handy";
import Contact_handyman from "./Contact_handyman";
import Video_handyman from "./Video_handyman";

const handymans = require("./images/for_handymans.PNG");
const Handymans = () => {
  return (
    <section className="pb-14">
      <Nav />
      <div className="max-w-screen-xl mx-auto px-4 text-gray-600 gap-x-12 items-start justify-between lg:flex md:px-8 mt-8">
        <div className="sm:hidden lg:block lg:max-w-xl">
          <img
            fetchpriority="low"
            src={handymans}
            className="rounded-lg shadow-2xl"
            alt="Bacome a handyman"
          />
        </div>
        <div className="mt-6 gap-12 sm:mt-0 md:flex lg:block">
          <div className="max-w-2xl">
            <h3 className="text-gray-800 text-3xl font-semibold sm:text-4xl">
              Get hired on-demand as a handyman in your area
            </h3>
            <p className="mt-3 max-w-xl">
              <span className="font-semibold text-md text-orange-600">
                Are you a skilled handyman?
              </span>{" "}
              Look no further! By joining our platform, you can easily get
              access to potential clients and get hired on-demand. Our platform
              connects you with individuals in need of handyman services in your
              local area, offering you the opportunity to grow your business and
              increase your income. Getting started is simple. Just fill out the
              form and wait for your account created.
            </p>
            <p className="font-bold text-lg my-5">
              Your next job is just a few clicks away!
            </p>

            <a href="#hire">
              <button className="px-20 py-4 text-white font-bold text-lg duration-150 bg-sky-600 rounded-full hover:bg-sky-500 active:bg-sky-700">
                Get hired
              </button>
            </a>
          </div>
          {/* <div className="flex-none mt-6 md:mt-0 lg:mt-6">
                      <ul className="inline-grid gap-y-8 gap-x-14 grid-cols-2">
                          {
                              stats.map((item, idx) => (
                                  <li key={idx} className="">
                                      <h4 className="text-4xl text-indigo-600 font-semibold">{item.data}</h4>
                                      <p className="mt-3 font-medium">{item.title}</p>
                                  </li>
                              ))
                          }
                      </ul>
                  </div> */}
        </div>
      </div>
      <Video_handyman />
      <div id="benefits">
        <h2 className="text-2xl px-2 sm:text-3xl mt-20 font-bold py-10 bg-orange-600 text-center text-white">
          There are several benefits to using our platform as a handyman
        </h2>
      </div>
      <div className="p-2 mt-2 pb-10 flex justify-center max-w-4xl flex-col mx-auto border-b shadow-lg">
        <ul>
          <li className="my-2">
            <div className="flex flex-row text-orange-500 items-center">
              <AiFillDatabase className="text-5xl mr-2" />
              <h2 className="mb-2 text-2xl font-bold ">
                Access to a Larger Client Base
              </h2>
            </div>

            <p className="ml-14 text-sky-800 font-semibold text-sm">
              By joining our platform, you gain access to a wide pool of
              potential clients actively seeking handyman services. This means a
              more consistent flow of job opportunities.
            </p>
          </li>

          <li className="my-5">
            <div className="flex flex-row  text-orange-500 items-center">
              <AiFillControl className="text-5xl mr-2" />
              <h2 className="mb-2 text-2xl font-bold">
                Flexibility and Control
              </h2>
            </div>

            <p className="ml-14 text-sky-800 font-semibold text-sm">
              You have the flexibility to choose the jobs that match your skills
              and availability. You're in control of your schedule and can take
              on as much or as little work as you desire.
            </p>
          </li>

          <li className="my-5">
            <div className="flex flex-row  text-orange-500 items-center">
              <AiFillDollarCircle className="text-5xl mr-2" />
              <h2 className="mb-2 text-2xl font-bold text-orange-500">
                Increased Income
              </h2>
            </div>
            <p className="ml-14 text-sky-800 font-semibold text-sm">
              With a steady stream of clients, you can significantly boost your
              income. More jobs mean more opportunities to earn money doing what
              you're skilled at.
            </p>
          </li>

          <li className="my-5">
            <div className="flex flex-row  text-orange-500 items-center">
              <AiFillLike className="text-5xl mr-2" />
              <h2 className="mb-2 text-2xl font-bold text-orange-500">
                Reduced Marketing Efforts
              </h2>
            </div>
            <p className="ml-14 text-sky-800 font-semibold text-sm">
              You won't need to invest as much time and money in marketing and
              advertising your services. Clients come to you through the
              platform, saving you valuable resources.
            </p>
          </li>

          <li className="my-5">
            <div className="flex flex-row  text-orange-500 items-center">
              <AiFillSmile className="text-5xl mr-2" />
              <h2 className="mb-2 text-2xl font-bold text-orange-500">
                Reviews and Reputation Building
              </h2>
            </div>
            <p className="ml-14 text-sky-800 font-semibold text-sm">
              Positive client reviews can enhance your reputation as a reliable
              and skilled handyman. The platform often allows clients to leave
              feedback, helping you build trust with future clients.
            </p>
          </li>

          <li className="my-5">
            <div className="flex flex-row  text-orange-500 items-center">
              <AiFillCheckCircle className="text-5xl mr-2" />
              <h2 className="mb-2 text-2xl font-bold text-orange-500">
                Convenience
              </h2>
            </div>
            <p className="ml-14 text-sky-800 font-semibold text-sm">
              Our platform provides an easy and convenient way for clients to
              find and hire you. Likewise, it simplifies your job search, making
              it more efficient and hassle-free.
            </p>
          </li>
          <li className="my-5">
            <div className="flex flex-row  text-orange-500 items-center">
              <AiFillSecurityScan className="text-5xl mr-2" />
              <h2 className="mb-2 text-2xl font-bold text-orange-500">
                Safety and Security
              </h2>
            </div>
            <p className="ml-14 text-sky-800 font-semibold text-sm">
              Reputable platforms often prioritize security, both for clients
              and service providers. This can provide peace of mind when working
              with new clients.
            </p>
          </li>
          <li className="my-5">
            <h2 className="mb-2 text-md p-3 text-sky-800">
              In summary, using our platform as a handyman can open up new
              opportunities, increase your income, and simplify the process of
              finding and connecting with clients. It offers a win-win situation
              for both handymen and those seeking their services.
            </h2>
          </li>
          <li>
            <p className="font-bold sm:text-3xl p-3 my-5 text-orange-600">
              Your next job is just a few clicks away!
            </p>
            <a href="#hire">
              <button className="px-20 py-4 ml-2 text-white font-bold text-lg duration-150 bg-sky-600 rounded-full hover:bg-sky-500 active:bg-sky-700">
                Get hired
              </button>
            </a>
          </li>
        </ul>
      </div>
      <Benefits />
      <FAQHandy />
      {/* <CTA_hired /> */}
      <Hire />
      {/* <Contact_handyman /> */}
    </section>
  );
};

export default Handymans;
